module.exports = __webpack_public_path__ + "static/img/view10-5.f82e08f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view10-5.png
// module id = +HGc
// module chunks = 1